import React from 'react'
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaMinus,
  FaTimes,
} from 'react-icons/fa'

import data from './data.json'

const CurrentStatus = () => {
  function renderStatus(status) {
    switch (status) {
      case 'ready':
        return (
          <div className="success">
            <FaCheckCircle />
          </div>
        )
      case 'inProgress':
        return (
          <div className="warning">
            <FaExclamationCircle />
          </div>
        )
      case 'notStarted':
        return (
          <div className="null">
            <FaMinus />
          </div>
        )
      case 'deprecated':
        return (
          <div className="danger">
            <FaTimes />
          </div>
        )
      default:
        return null
    }
  }
  return (
    <>
      {/* <h2>Current Version {data.version}</h2> */}
      <p>Released {data.releaseDate}</p>

      <h2 class="section-title">
        Component <span class="unbold">Status</span>
      </h2>
      <table className="current-status-table">
        <thead>
          <tr>
            <th align="left">Component</th>
            <th>Design</th>
            <th>HTML/CSS</th>
            {/* <th>Angular</th> */}
            <th>Document</th>
            <th>Release</th>
          </tr>
        </thead>

        <tbody>
          {data.components.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>{renderStatus(item.design)}</td>
              <td>{renderStatus(item.html)}</td>
              {/* <td>{renderStatus(item.angular)}</td> */}
              <td>{renderStatus(item.document)}</td>
              <td>{renderStatus(item.release)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h2 class="section-title">
        Pattern <span class="unbold">Status</span>
      </h2>
      <table className="current-status-table">
        <thead>
          <tr>
            <th align="left">Pattern</th>
            <th>Design</th>
            <th>HTML/CSS</th>
            {/* <th>Angular</th> */}
            <th>Document</th>
            <th>Release</th>
          </tr>
        </thead>

        <tbody>
          {data.patterns.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>{renderStatus(item.design)}</td>
              <td>{renderStatus(item.html)}</td>
              {/* <td>{renderStatus(item.angular)}</td> */}
              <td>{renderStatus(item.document)}</td>
              <td>{renderStatus(item.release)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 class="section-title">
        Layout <span class="unbold">Status</span>
      </h2>
      <table className="current-status-table">
        <thead>
          <tr>
            <th align="left">Layout</th>
            <th>Design</th>
            <th>HTML/CSS</th>
            <th>Document</th>
            <th>Release</th>
          </tr>
        </thead>

        <tbody>
          {data.layout.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>{renderStatus(item.design)}</td>
              <td>{renderStatus(item.html)}</td>
              <td>{renderStatus(item.document)}</td>
              <td>{renderStatus(item.release)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 class="section-title">
        Utility <span class="unbold">Status</span>
      </h2>
      <table className="current-status-table">
        <thead>
          <tr>
            <th align="left">Utility</th>
            <th>Design</th>
            <th>HTML/CSS</th>
            <th>Document</th>
            <th>Release</th>
          </tr>
        </thead>

        <tbody>
          {data.utility.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>{renderStatus(item.design)}</td>
              <td>{renderStatus(item.html)}</td>
              <td>{renderStatus(item.document)}</td>
              <td>{renderStatus(item.release)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}
export default CurrentStatus
